import api from "./BaseAPI.js";
import auth from "./AuthAPI.js";
import Http from "./Http.js";
import * as APPCONFIG from "../config/app-config.js";

const BASE = `${APPCONFIG.API_URL}auth/v1/blogs`;

class BlogApi {

  // ── PUBLIC — landing page ─────────────────────────────────────────────

  getFeaturedBlogs() {
    // FIX: use auth() not api() — api() sends no token, server may reject
    return api({
      method: "get",
  
      url: `${BASE}/featured`,
    });
  }

  getBlogById(id) {
    return api({
      method: "get",

      url: `${BASE}/public/${id}`,
    });
  }

  getPublishedBlogs() {
    return api({
      method: "get",
      url: `${BASE}/public`,
    });
  }

}

export default new BlogApi();